module.exports = __webpack_public_path__ + "img/clogo.c25dca5b.png";